module.exports = __webpack_public_path__ + "static/img/prezzta2.29af4b3c.svg";